import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { SettingsFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { RemoveEmployeeFormProps } from "models/propTypes/settingsPropTypes";
import { FormEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { GenericForm } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const RemoveEmployeeForm: ForwardRefRenderFunction<FormHandles, RemoveEmployeeFormProps> = (props, ref) => {
  const { employeeName, isSalaryActive } = props;

  return (
    <Grid container rowSpacing={1}>
      <Grid item>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Settings.RemoveEmployee, "", {
          name: `${employeeName}`,
        })}
      </Grid>
      <Grid item>
        <GenericForm<SettingsFormTypes.RemoveEmployee>
          formRef={ref}
          {...props}
          enableControlLables
          formGridLayout={{ message: false }}
          fields={{
            employmentEndDate: {
              controlLabel: TranslationKeys.Salary.ActiveSalary,
              label: TranslationKeys.Common.EndDate,
              descriptionText: TranslationKeys.Salary.ActiveSalaryDescription,
              type: FormEnums.FormFieldType.DATE,
              hidden: !isSalaryActive,
            },
          }}
        />
      </Grid>
    </Grid>
  );
};

export default forwardRef(RemoveEmployeeForm);
